/**
 * The supported set of object types, according to the picking implementation
 */
export var ObjectType;
(function (ObjectType) {
    ObjectType[ObjectType["Composite"] = 0] = "Composite";
    ObjectType[ObjectType["Primitive"] = 1] = "Primitive";
})(ObjectType || (ObjectType = {}));
/**
 * Manager class that handles allocating picking IDs and mapping those IDs back to the objects they refer to
 */
export class PickingManager {
    constructor() {
        /**
         * Object ID state. Object IDs are generated monotonically using this as the state.
         * @private
         */
        this.nextId = 1;
        this.objectData = new Map();
        this.threeIdToOurIdMap = new Map();
    }
    /**
     * Allocate a new ID and return it. This ID is guaranteed to be unique and will never be yielded a second time from
     * the same PickingManager instance.
     */
    newId() {
        const out = this.nextId;
        this.nextId += 1;
        return out;
    }
    /**
     * Set data for the given object ID.
     * @param id
     * @param data
     */
    setForId(id, data) {
        this.objectData.set(id, data);
    }
    /**
     * Returns the object the ID maps to. Will throw if the ID has been removed.
     * @param id
     */
    getForId(id) {
        return this.objectData.get(id);
    }
    /**
     * Remove the data for the given object ID from the manager.
     * @param id
     */
    removeForId(id) {
        return this.objectData.delete(id);
    }
    setIdForObject(threeId, id) {
        this.threeIdToOurIdMap.set(threeId, id);
    }
    getIdForThreeId(threeId) {
        return this.threeIdToOurIdMap.get(threeId);
    }
    removeForObject(threeId) {
        return this.threeIdToOurIdMap.delete(threeId);
    }
}
